import Head from "next/head";
import dynamic from "next/dynamic";
import SuperFetch from "../Api/superFetch";
import { useRouter } from "next/router";
import styles from "../styles/components/Home.module.scss";
import React, { useState, useEffect } from "react";
import useTranslation from "next-translate/useTranslation";
import { isServer } from "../helpers/common";
const Footer = dynamic(() => import("../components/Footer"));
const Header = dynamic(() => import("../components/Header"));
const Heading = dynamic(() => import("../components/Heading"));
const PressRelease = dynamic(() => import("../components/PressRelease"));
const Separator = dynamic(() => import("../components/Utility/Separator"));
const SubscribeCard = dynamic(() => import("../components/SubscribeCard"));

function PressReleases({
  authKeys,
  subscriptions,
  subscriptionInfo,
  userDetails,
  signupBook,
  fullUrl,
  origin,
  post,
  investorsPressReleases,
}) {
  const { t } = useTranslation();
  const router = useRouter();
  const { locale } = router;
  const url = `${origin}${fullUrl}`;
  const tempCode = locale.substring(0, 2).toUpperCase();
  const defaultImage = `${origin}/cdn/images/nextory-share-pink.jpg`;
  const isLoggedIn = userDetails.isLoggedIn;

  const [pressReleases, setPressReleases] = useState(investorsPressReleases);
  const [totalReleases, setTotalReleases] = useState(
    investorsPressReleases?.TotalFoundReleases
  );
  const [pageIndex, setPageIndex] = useState(1);
  const [regulatory, setRegulatory] = useState(false);
  const [selectedYear, setSelectedYear] = useState("All years");
  const [selectedLang, setSelectedLang] = useState("English");
  const [loading, setLoading] = useState(false);
  const [morePressReleases, setMorePressReleases] = useState(false);
  const [renderMoreReleases, setRenderMoreReleases] = useState(true);
  const [currentPage, setCurrentPage] = useState('');

  useEffect(() => {
    if (pageIndex > 1) {
      fetchPressReleases(selectedYear, regulatory, true, selectedLang);
    } else {
      fetchPressReleases(selectedYear, regulatory, false, selectedLang);
    }
    if(!isServer){
      setCurrentPage(window.location.href);

    }

  }, [pageIndex, regulatory, selectedYear, selectedLang]);

  const fetchPressReleases = async (year, bool, append = false, lang = '') => {
    let langKey = process.env.CISION_FEEDS_KEY_EN;
    if(lang === 'Swedish'){
      langKey = process.env.CISION_FEEDS_KEY_SE;
    }
    setLoading(true);
    let url;
    if (year === "All years") {
      url = `https://publish.ne.cision.com/papi/NewsFeed/${langKey}?format=json&pageSize=5&pageIndex=${pageIndex}&Regulatory=${bool}`;
    } else {
      url = `https://publish.ne.cision.com/papi/NewsFeed/${langKey}?format=json&pageSize=5&pageIndex=${pageIndex}&Regulatory=${bool}&StartDate=${year}-01-01`;
    }

    const fetchInvestorsPressReleases = await SuperFetch.get({
      url,
    });
    setLoading(false);
    setMorePressReleases(false);

    if (fetchInvestorsPressReleases.status == 200) {
      if (append) {
        fetchInvestorsPressReleases.Releases = [
          ...pressReleases.Releases,
          ...fetchInvestorsPressReleases.Releases,
        ];
        setPressReleases(fetchInvestorsPressReleases || null);
      } else {
        setPressReleases(fetchInvestorsPressReleases || null);
      }
    }

    fetchInvestorsPressReleases?.TotalFoundReleases >
    fetchInvestorsPressReleases.Releases.length
      ? setRenderMoreReleases(true)
      : setRenderMoreReleases(false);

    setSelectedYear(year);
    setRegulatory(bool);
    setTotalReleases(fetchInvestorsPressReleases?.TotalFoundReleases);
  };

  const onChangeYear = (year) => {
    setPageIndex(1);
    setSelectedYear(year);
  };

  const onChangeLanguage = (lang) => {
    console.log('lang', lang)
    setPageIndex(1);
    setSelectedLang(lang);
  };

  const onToggleRegulatory = (bool) => {
    setPageIndex(1);
    setRegulatory(bool);
  };

  const onFetchMorePressReleases = () => {
    if (totalReleases > pressReleases.Releases.length) {
      setMorePressReleases(true);
      setPageIndex(pageIndex + 1);
    }
  };

  const menu = !isLoggedIn ? "noBg" : "registeredUser";
  return (
    <>
      <Head>
        <title>{t("lang_common:seo.title")}</title>
        <link rel="alternate" href={`${origin}`} hrefLang={tempCode} />
        <meta httpEquiv="Content-Language" content={locale} />
        <meta name="name" content={t(`lang_seo:generic.title`)} />
        <meta name="description" content={t("lang_common:seo.description")} />
        <meta name="image" content={defaultImage} />
        <meta
          name="og:description"
          content={t(`lang_seo:generic.ogDescription`)}
        />
        <meta name="og:title" content={t("lang_seo:generic.ogTitle")} />
        <meta name="og:site_name" content={t("lang_seo:generic.ogSiteName")} />
        <meta name="og:image" content={defaultImage} />
        <meta name="og:url" content={url} />
        <meta name="fb:app_id" content={`${process.env.FB_ID}`} />
        <link
          rel="preload"
          href="/fonts/body/nextorysans-medium.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/fonts/body/nextorysans-regular.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/fonts/headline/nextorysans-headline-demibold.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link rel="canonical" href={url} data-react-helmet="true"></link>
        {/* <script
              id="Cookiebot"
              type="text/javascript"
              src={`https://consent.cookiebot.com/uc.js?cbid=75a257d3-f364-4c99-9c0b-9c181c509196&culture=${tempCode}`}
              defer
          /> */}
      </Head>
      <div id="newUI" className={styles.app}>
        <main className={styles.main}>
          <Header
            authKeys={authKeys}
            subscriptions={subscriptions}
            subscriptionInfo={subscriptionInfo}
            userDetails={userDetails}
            signupBook={signupBook}
            noBackground={menu}
            searchIcon={"dark"}
            modifiers={"investors"}
          />

          {/* Press Releases Large */}
          <Heading center header={"Press releases"} />
          <PressRelease
            presReleases={pressReleases}
            post={post}
            onChangeYear={onChangeYear}
            onChangeLanguage={onChangeLanguage}
            onToggleRegulatory={onToggleRegulatory}
            onFetchMorePressReleases={onFetchMorePressReleases}
            pressReleaseDetail
            loading={loading}
            morePressReleases={morePressReleases}
            renderMoreReleases={renderMoreReleases}
            selectedLang={selectedLang}
          />
          <Separator spaceBottom />
          <Heading center header={"Subscribe"} />
          <SubscribeCard
            uniqueIdentifier={process.env.CISION_SUBSCRIPTION_KEY}
            successUrl={`${currentPage}?success=true`}
            failureUrl={`${currentPage}?failure=true`}
            successMsg={
              router.query && router.query.success
                ? `Thank you for subscribing!`
                : null
            }
            failureMsg={
              router.query && router.query.failure
                ? `You've already subscribed to this newsletter!`
                : null
            }
          />

          <Footer spaceTop userDetails={userDetails} />
        </main>
      </div>
    </>
  );
}

export default PressReleases;
